import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-badge-pill',
  templateUrl: './badge-pill.component.html',
  styleUrls: ['./badge-pill.component.scss']
})
export class BadgePillComponent implements OnInit {
  @Input() text: string;
  @Input() color: string; // This has to be hexcode

  constructor() { }

  ngOnInit(): void {
  }

  lightenColor(color: string): string {  
    // Convert color to RGB
    const rgb = this.hexToRgb(color);
  
    // Calculate lightened color (you can adjust the factor as needed)
    const factor = .6; // You can adjust this factor
    const newRgb = {
      r: Math.min(255, rgb.r + 255 * factor),
      g: Math.min(255, rgb.g + 255 * factor),
      b: Math.min(255, rgb.b + 255 * factor)
    };
  
    // Convert RGB back to hex
    return this.rgbToHex(newRgb.r, newRgb.g, newRgb.b);
  }
  
  hexToRgb(hex: string): { r: number, g: number, b: number } {
    const bigint = parseInt(hex.slice(1), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
    return { r, g, b };
  }
  
  rgbToHex(r: number, g: number, b: number): string {
    return "#" + ((1 << 24) + (r << 16) + (g << 8) + b).toString(16).slice(1);
  }

}
